import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";
import AdminWorkspaceTimeline from "@/components/admin/admin-workspace-timeline";

const AdminWorkspaceTimelinePage = (): JSX.Element => {
	const { workspaceId } = Route.useParams();
	return <AdminWorkspaceTimeline workspaceId={workspaceId} />;
};

export const Route = createFileRoute("/_app/admin/workspaces/$workspaceId/timeline")({
	component: AdminWorkspaceTimelinePage,
});
